<template>
  <span>
    <v-tooltip v-if="exportDisabled" top right offset-y>
      <template v-slot:activator="{ on, attrs }">
        <span v-bind="attrs" v-on="on">
          <v-btn
            :disabled="true"
            fab
            small
            color="primary"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </span>
      </template>
      <span>Not available from this view</span>
    </v-tooltip>
    <v-menu v-else offset-y bottom right open-on-hover close-delay="500">
      <template v-slot:activator="{ on, attrs }">
        <v-btn fab small color="primary" v-bind="attrs" v-on="on">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item v-if="!disableExports" link @click="buttonClick('downloadExport')">
          <v-list-item-icon class="grey--text text--darken-1 mr-2">
            <custom-icon name="download-export"></custom-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="grey--text text--darken-1">Download Report</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-else>
          <v-list-item-icon class="grey--text text--lighten-1 mr-2">
            <custom-icon name="download-export"></custom-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="grey--text text--lighten-1">Download Report</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      
        <v-list-item v-if="!disableDeliveries" link @click="buttonClick('scheduleExport')">
          <v-list-item-icon class="grey--text text--darken-1 mr-2">
            <custom-icon name="schedule-export"></custom-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="grey--text text--darken-1">Schedule Report Delivery</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-else>
          <v-list-item-icon class="grey--text text--lighten-1 mr-2">
            <custom-icon name="schedule-export"></custom-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="grey--text text--lighten-1">Schedule Report Delivery</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </span>
</template>
<script>

const TEAM_ALLOWED_PAGES = ['scorecards-v2-agents', 'scorecards-v2-calls'];

export default {
  props: {
    disableDeliveries: {
      type: Boolean,
      required: false,
      default: false,
    },
    disableExports: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  computed: {
    exportDisabled() {
      //currently exports are disabled from the call and agent scoreccard pages if a team id is set
      return (TEAM_ALLOWED_PAGES.includes(this.$route.name) && this.$route.query.hasOwnProperty("team_id")) || this.$route.name == 'task-summary'
    }
  },
  methods: {
    buttonClick(button) {
      this.$emit('exportClick', button)
    },
  }
}
</script>
